<template>
  <div class="ts-w-screen ts-flex ts-flex-col qr-code-page">
    <ts-loading-banner :loading="loading">
      <img
        class="ts-flex ts-items-center ts-justify-start ts-object-cover"
        :src="logo"
        style="width: 150px;"
      />
      <div class="certiifcate-info">
        <div class="ts-pb-3 ts-font-bold" v-if="isValidQr">
          <div>
            {{ resources ? resources.degree_kh : '' }} > Brachñasastra
            Technology Institute
            {{ getLevelByDegree(resources ? resources.degree : '') }}
          </div>
          <div>
            គុណវុឌ្ឍិជាតិ
            {{ getLevelKhByDegree(resources ? resources.degree : '') }}
          </div>
        </div>
        <ts-card>
          <ts-card-wrapper v-if="isValidQr">
            <div class="image-profile ts-flex ts-items-center gap-y-8 mb-16">
              <img
                class="lecturer-profile ng-star-inserted"
                :src="photo(resources)"
                @error="onError(resources)"
              /><span>{{ resources ? resources.certificate_number : '' }}</span>
            </div>
            <b>ព័ត៌មានទូទៅ</b>
            <div
              class="ts-grid xs:ts-grid-cols-1 sm:ts-grid-cols-2 md:ts-grid-cols-2"
            >
              <div class="ts-grid ts-grid-cols-2 detail-text">
                <span>Full Name:</span>
                <div class="ts-font-bold">
                  {{ resources ? resources.student_name_en : '' }}
                </div>
              </div>
              <div class="ts-grid ts-grid-cols-2 detail-text">
                <span>ឈ្មោះ:</span>
                <div class="ts-font-bold">
                  {{ resources ? resources.student_name_kh : '' }}
                </div>
              </div>
              <div class="ts-grid ts-grid-cols-2 detail-text">
                <span>​Gender:</span>
                <div class="ts-font-bold">
                  {{ resources ? resources.gender : '' }}
                </div>
              </div>
              <div class="ts-grid ts-grid-cols-2 detail-text">
                <span>ភេទ:</span>
                <div class="ts-font-bold">
                  {{ resources ? resources.gender_kh : '' }}
                </div>
              </div>
              <div class="ts-grid ts-grid-cols-2 detail-text">
                <span>Date of birth:</span>
                <div class="ts-font-bold">
                  {{ resources ? resources.date_of_birth : '' }}
                </div>
              </div>
              <div class="ts-grid ts-grid-cols-2 detail-text">
                <span>ថ្ងៃខែឆ្នាំកំណើត:</span>
                <div class="ts-font-bold">
                  {{ resources ? resources.date_of_birth_kh : '' }}
                </div>
              </div>
              <div class="ts-grid ts-grid-cols-2 detail-text">
                <span>Examination Committee:</span>
                <div class="ts-font-bold">
                  Brachñasastra Technology Institute
                </div>
              </div>
              <div class="ts-grid ts-grid-cols-2 detail-text">
                <span>គណ:កម្មាការប្រឡង:</span>
                <div class="ts-font-bold">
                  វិទ្យាស្ថានបច្ចេកវិទ្យាប្រាជ្ញាសាស្ត្រ
                </div>
              </div>
              <div class="ts-grid ts-grid-cols-2 detail-text">
                <span>Specialties:</span>
                <div class="ts-font-bold">
                  {{ resources ? resources.major : '' }}
                </div>
              </div>
              <div class="ts-grid ts-grid-cols-2 detail-text">
                <span>ជំនាញ:</span>
                <div class="ts-font-bold">
                  {{ resources ? resources.major_kh : '' }}
                </div>
              </div>
              <div class="ts-grid ts-grid-cols-2 detail-text">
                <span>Exam Date:</span>
                <div class="ts-font-bold">
                  {{ resources ? resources.exam_date : '' }}
                </div>
              </div>
              <div class="ts-grid ts-grid-cols-2 detail-text">
                <span>សម័យប្រឡងបញ្ចប់:</span>
                <div class="ts-font-bold">
                  {{ resources ? resources.exam_date_kh : '' }}
                </div>
              </div>
            </div>
          </ts-card-wrapper>
          <ts-card-wrapper v-else>
            <h1 class="ts-text-center">
              អ្នកក្លែង QR Code នឹងត្រូវផ្តន្ទាទោសតាមច្បាប់
            </h1>
          </ts-card-wrapper>
        </ts-card>
        <ts-card class="ts-mt-4" v-if="resources">
          <ts-card-wrapper>
            <b>សមត្ថភាព</b>
            <div class="mb-24 mt-12">
              <b>សមត្ថភាពមូលដ្ឋាន (BASIC COMPETENCY)</b>
            </div>
            <div class="ts-grid ts-gap-x-12 ts-grid-cols-3 mb-12 detail-text">
              <div class="ts-grid ts-gap-x-12 ts-grid-cols-2">
                <label class="value">លេខកូដ</label>
              </div>
              <div class="ts-grid ts-gap-x-12 ts-grid-cols-2">
                <label class="value">ឈ្មោះ</label>
              </div>
              <div class="ts-grid ts-gap-x-12 ts-grid-cols-2">
                <label class="value">Name</label>
              </div>
            </div>
            <div
              class="ts-grid ts-grid-cols-3 ts-gap-x-12 mt-12 detail-text ng-star-inserted"
              v-for="basic in resources.basic_competency"
            >
              <div class="ts-grid ts-gap-x-12">
                <span>{{ basic.subject_code }}</span>
              </div>
              <div class="ts-grid ts-gap-x-12">
                <span>{{ basic.subject_name_kh }}</span>
              </div>
              <div class="ts-grid ts-gap-x-12">
                <span>{{ basic.subject_name_en }}</span>
              </div>
            </div>
            <div class="mt-16 mb-16">
              <b>សមត្ថភាពស្នូល (CORE COMPETENCY)</b>
            </div>
            <div class="ts-grid ts-gap-x-12 ts-grid-cols-3 mb-12 detail-text">
              <div class="ts-grid ts-gap-x-12 ts-grid-cols-2">
                <label class="value">លេខកូដ</label>
              </div>
              <div class="ts-grid ts-gap-x-12 ts-grid-cols-2">
                <label class="value">ឈ្មោះ</label>
              </div>
              <div class="ts-grid ts-gap-x-12 ts-grid-cols-2">
                <label class="value">Name</label>
              </div>
            </div>
            <div
              class="ts-grid ts-grid-cols-3 ts-gap-x-12 mt-12 detail-text ng-star-inserted"
              v-for="core in resources.core_competency"
            >
              <div class="ts-grid ts-gap-x-12">
                <span>{{ core.subject_code }}</span>
              </div>
              <div class="ts-grid ts-gap-x-12">
                <span>{{ core.subject_name_kh }}</span>
              </div>
              <div class="ts-grid ts-gap-x-12">
                <span>{{ core.subject_name_en }}</span>
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
        <ts-card-wrapper>
          <div class="ts-pb-3 ts-leading-relaxed">
            <div class="ts-font-bold ts-grid ts-grid-cols-2">
              <div class="ts-grid ts-gap-x-12 whitespace-nowrap">កំណត់ហេតុចុះថ្ងៃ៖</div>
              <div class="ts-grid ts-gap-x-12">
                {{ resources ? resources.request_date_kh : '' }}
              </div>
            </div>
            <div class="ts-font-bold ts-grid ts-grid-cols-2">
              <div class="ts-grid ts-gap-x-12 whitespace-nowrap">Minute of Examination:</div>
              <div class="ts-grid ts-gap-x-12">
                {{ resources ? resources.request_date : '' }}
              </div>
            </div>
            <div class="ts-font-bold">
              ទំនាក់ទំនង &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Brachñasastra
              Technology Institute, Kampong Speu
            </div>
            <div>
              <b>លេខទូរស័ព្ទ</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(855) 092 399 993
              / 096 484 4844
            </div>
            <div class="ts-font-bold">ម៉ោងធ្វើការ</div>
            <div>
              ថ្ងៃចន្ទ-សុក្រ និងសៅរ៍-អាទិត្យ ៧:០០ នាទីព្រឹក ដល់ម៉ោង ៥:៣០
              នាទីល្ងាច
            </div>
            <div class="ts-font-bold">ទីតាំង</div>
            <div>
              ភូមិពាណិជ្ជកម្ម សង្កាត់រការធំ ក្រុងច្បារមន ខេត្តកំពង់ស្ពឺ។
            </div>
          </div>
        </ts-card-wrapper>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import PageOptions from '../config/PageOptions.vue'
import { isEmpty } from 'lodash'
export default {
  name: 'DisplayCertificate',
  data() {
    return {
      logo: require('@/assets/bti-logo.png'),
      manPhoto: require('@/assets/staff-default-man.png'),
      womenPhoto: require('@/assets/staff-default-women.png'),
      token: null,
      resources: null,
      loading: false
    }
  },
  created() {
    this.logout()
    const token = this.$route.query.token
    this.token = token
    PageOptions.pageEmpty = true
    document.body.className = 'bg-white'
    this.$root.$i18n.locale = 'kh'
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    document.body.className = ''
    next()
  },
  computed: {
    locale() {
      return this.$root.$i18n.locale
    },
    isValidQr() {
      return !isEmpty(this.resources)
    }
  },
  methods: {
    handleIcon(company) {
      // accessing the link tag
      const favicon = document.getElementById('favicon')
      const title = document.getElementById('title')
      title.innerHTML = company.company_name_en
      favicon.href = company.favicon
    },
    handleChangeLang: function(code) {
      this.$root.$i18n.locale = code
    },
    async logout() {
      await this.$store.dispatch('logout')
    },
    fetchData() {
      this.loading = true
      this.resources = null
      this.$store
        .dispatch('certificateOperationPrint/qrCodeScan', { token: this.token })
        .then(response => {
          this.resources = response
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    getLevelByDegree: function(degree) {
      if (degree == 'Associate') {
        return 'Level 5'
      }
      if (degree == 'Bachelor') {
        return 'Level 6'
      }
      if (degree == 'Master') {
        return 'Level 7'
      }
      if (degree == 'Doctor') {
        return 'Level 8'
      }
    },
    getLevelKhByDegree: function(degree) {
      if (degree == 'Associate') {
        return 'កម្រឹត​​ ៥'
      }
      if (degree == 'Bachelor') {
        return 'កម្រឹត​​ ៦'
      }
      if (degree == 'Master') {
        return 'កម្រឹត​​ ៧'
      }
      if (degree == 'Doctor') {
        return 'កម្រឹត​​ ៨'
      }
    },
    photo(record) {
      if (!record) {
        return this.manPhoto
      }
      if (record.photo) {
        return record.photo
      }
      return record.gender == 'Male' ? this.manPhoto : this.womenPhoto
    },

    onError(record) {
      event.target.src =
        record.gender == 'Male' ? this.manPhoto : this.womenPhoto
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
<style scoped>
.qr-code-page {
  background-blend-mode: multiply;
  background-color: #f4f5f4;
  margin: auto;
  min-width: 400px;
  color: rgb(48, 48, 48);
}
@media all and (min-width: 1367px) {
  .qr-code-page {
    max-width: 40%;
  }
}
.certiifcate-info {
  padding: 15px;
}
table {
  width: 98%;
  border-collapse: collapse;
  font-family: 'Khmer OS Battambang';
  background-color: #fff;
}
td {
  border: 1px rgb(139, 139, 139) solid;
  padding: 6px 3px;
  font-size: 12px;
  text-align: left;
  border-color: #32a1ce;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.detail-text {
  padding: 6px 2px;
  border-bottom: 1px solid #f4f4f7;
}
.image-profile {
  justify-content: center;
  flex-direction: column;
}
.image-profile .lecturer-profile {
  width: 110px;
  border-radius: 3px;
}
.font-khmer-moul {
  font-family: 'Khmer OS Muol Light';
}
</style>
